var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClearCart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 17.2 17.4",
    xmlSpace: "preserve",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_677",
    transform: "translate(-345.021 -46.252)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "shopping-cart_1_",
    transform: "translate(345.021 17.419)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20",
    cx: 7.8,
    cy: 42.7,
    r: 1.3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_21",
    cx: 11.9,
    cy: 42.7,
    r: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_529",
    d: "M1.8,31.9h1.8l2,7.2l-0.2,0.3C5.1,40,5.4,40.8,6,41.1c0.2,0.1,0.4,0.1,0.6,0.1h7.1c0.2,0,0.4-0.2,0.4-0.4 c0-0.2-0.2-0.4-0.4-0.4H6.6c-0.2,0-0.4-0.2-0.4-0.4c0-0.1,0-0.1,0-0.2l0.1-0.2h7.4c0.2,0,0.4-0.1,0.4-0.3l1.7-5.9 c0.1-0.2-0.1-0.5-0.3-0.5c0,0-0.1,0-0.1,0H4.7l-0.4-1.4c-0.1-0.2-0.2-0.3-0.4-0.3H1.8c-0.2,0-0.4,0.2-0.4,0.4S1.5,31.9,1.8,31.9 L1.8,31.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Line_41"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 345.9,
    y: 54.6,
    transform: "matrix(0.4959 -0.8684 0.8684 0.4959 131.2691 335.9822)",
    width: 18.2,
    height: 0.8
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearCart);
export default __webpack_public_path__ + "static/media/clear_cart.f55b584a.svg";
export { ForwardRef as ReactComponent };